// extracted by mini-css-extract-plugin
module.exports = {"story":"jgp-QyPsj"};